import { BaseModel, ID } from '@models/base'

import { ClinicModel } from './clinic'
import { InsuranceModel } from './insurance'
import { InsurancePayorModel } from './insurancePayor'
import { NurseModel } from './nurse'
import { PatientPreviewModel } from './patientPreview'
import { PatientRelativePreviewModel } from './patientRelativePreview'

enum PatientVisitTypeEnum {
  CONSULTATION = 'CONSULTATION',
  HEALTH_SCREENING = 'HEALTH_SCREENING',
  TAKE_MEDICINE = 'TAKE_MEDICINE',
  VACCINATION = 'VACCINATION',
  MEDICAL_CHECKUP = 'MEDICAL_CHECKUP',
}

type PatientVisitModel = BaseModel & {
  clinic: ClinicModel | null
  insurance: InsuranceModel | null
  insurance_card_number: string | null
  insurance_payor: InsurancePayorModel | null
  note: string | null
  nurse: NurseModel | null
  patient: PatientPreviewModel | null
  patient_relative: PatientRelativePreviewModel | null
  patient_relative_id: ID | null
  type: PatientVisitTypeEnum
  visited_at: string
}

type PatientVisitPreviewDataPrintLabelModel = {
  birth_date: string
  name_lines: string[]
  nik_or_passport: string
}

type AmendmentDataModel = {
  medicalRecordId: ID
  amendment: string | null
}

type AmmendmentHistoryDataModel = {
  medicalRecordId: ID
  doctorId?: ID
}

export { PatientVisitTypeEnum }

export type {
  PatientVisitModel,
  PatientVisitPreviewDataPrintLabelModel,
  AmendmentDataModel,
  AmmendmentHistoryDataModel,
}
